import { NgModule } from '@angular/core';
import { PatientCodePipe } from './patient-code.pipe';
import { PatientSexPipe } from './patient-sex.pipe';
import { PatientEthnicityPipe } from './patient-ethnicity.pipe';

@NgModule({
declarations: [
        PatientCodePipe,
        PatientSexPipe,
        PatientEthnicityPipe
    ],
imports: [],
exports: [
        PatientCodePipe,
        PatientSexPipe,
        PatientEthnicityPipe
    ],
})

export class PipesModule {

}
